import React, { useContext, useEffect } from "react";
import { Snackbar, SnackbarOrigin } from "@mui/material";
import { Alert } from "./Alert";
import SnackBarContext from "../context/SnackBarContext";

export interface State extends SnackbarOrigin {
  open: boolean;
}

export const SnackbarComponent = (props: any) => {
  const { message, open, onClose, severity } = props;
  const snackBarMode = useContext(SnackBarContext);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        snackBarMode.toggleSnackbar("", "");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [open, snackBarMode]);

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={open}
        // onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={() => {
            // snackBarMode.toggleSnackbar(message, severity);
            if (onClose) {
              onClose!();
            }
          }}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
